export class DeleteProjectAction {
  static readonly type = '[Project] Delete Project';

  constructor(public projectId: string) {}
}
